import { DeliveryAddress } from '@/entities/preferences/delivery';

export const getAddressLine = (address: DeliveryAddress) => {
  const street2 = address.street2 ? `${address.street2},` : '';

  return `${address.street1}, ${street2} ${address.city} ${address.state} ${address.zipcode}`;
};
